// Wrappers de sanitização reutilizáveis (DOMPurify). Sem React.
// Usado pelo App e por todos os blocos.
import DOMPurify from 'dompurify';

// Texto puro — remove qualquer tag.
export const sanitizeText = (text) => {
  if (!text) return '';
  return DOMPurify.sanitize(text, { ALLOWED_TAGS: [] });
};

// HTML restrito (ex.: bio) — só formatação inline básica.
export const sanitizeHTML = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u'],
    ALLOWED_ATTR: [],
  });
};
